export const BitbucketLogoInverse = () => (
  <svg
    width="233"
    height="48"
    viewBox="0 0 233 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.193 19.2588H21.38L19.735 28.8688H12.914L4.913 38.3958C4.913 38.3958 5.272 38.7398 5.829 38.7398L27.121 38.7358C27.633 38.7358 28.07 38.3638 28.153 37.8588L31.192 19.2588H31.193Z"
      fill="url(#paint0_linear_818_535)"
    />
    <path
      d="M1.046 9.39697C0.401 9.39697 -0.0899995 9.97497 0.0140005 10.612L4.438 37.552C4.494 37.891 4.668 38.184 4.914 38.395C4.914 38.395 5.273 38.74 5.83 38.74L14.067 28.869H12.914L11.098 19.259H31.193L32.603 10.618C32.707 9.98197 32.216 9.40397 31.571 9.40397L1.046 9.39697Z"
      fill="white"
    />
    <path
      d="M49.445 8.51416H62.096C68.261 8.51416 71.251 11.5502 71.251 16.4272C71.251 20.0612 69.595 22.3162 66.19 23.1442C70.652 23.8792 72.861 26.3182 72.861 30.5962C72.861 35.4272 69.594 38.7402 62.832 38.7402H49.444V8.51416H49.445ZM53.586 12.4702V21.4882H61.545C65.455 21.4882 67.066 19.6932 67.066 16.7962C67.066 13.8522 65.318 12.4712 61.545 12.4712H53.586V12.4702ZM53.586 25.1672V34.5992H62.971C66.927 34.5992 68.722 33.1732 68.722 30.1362C68.722 26.9162 67.02 25.1672 62.879 25.1672H53.586Z"
      fill="white"
    />
    <path
      d="M79.621 6.9043C81.231 6.9043 82.381 7.9163 82.381 9.6653C82.381 11.4143 81.232 12.4253 79.621 12.4253C78.01 12.4253 76.86 11.4133 76.86 9.6653C76.86 7.9173 78.01 6.9043 79.621 6.9043ZM77.597 15.7373H81.554V38.7403H77.597V15.7373Z"
      fill="white"
    />
    <path
      d="M96.642 35.0139C97.562 35.0139 98.436 34.8289 99.126 34.6919V38.5099C98.436 38.6949 97.653 38.8779 96.457 38.8779C91.535 38.8779 89.143 35.9799 89.143 31.7009V19.4179H85.416V15.7369H89.143V10.8599H93.007V15.7369H99.126V19.4179H93.007V31.6089C93.007 33.6329 94.203 35.0129 96.642 35.0129V35.0139Z"
      fill="white"
    />
    <path
      d="M108.142 34.6911V38.7401H104.185V6.12207H108.142V19.8781C109.614 16.8421 112.374 15.2771 115.916 15.2771C122.035 15.2771 125.117 20.4751 125.117 27.2381C125.117 33.7251 121.896 39.2001 115.456 39.2001C112.098 39.2001 109.521 37.6811 108.142 34.6911ZM114.858 18.9581C111.316 18.9581 108.142 21.2121 108.142 26.3181V28.1591C108.142 33.2651 111.039 35.5191 114.398 35.5191C118.861 35.5191 121.161 32.5751 121.161 27.2381C121.161 21.7171 118.953 18.9581 114.858 18.9581Z"
      fill="white"
    />
    <path
      d="M129.254 15.7373H133.21V29.6313C133.21 33.7723 134.866 35.6113 138.639 35.6113C142.32 35.6113 144.85 33.1733 144.85 28.5263V15.7373H148.806V38.7403H144.85V34.9683C143.378 37.6823 140.663 39.2003 137.581 39.2003C132.29 39.2003 129.254 35.5653 129.254 29.2173V15.7373Z"
      fill="white"
    />
    <path
      d="M171.024 38.1409C169.643 38.8769 167.527 39.1999 165.411 39.1999C157.223 39.1999 153.404 34.2309 153.404 27.1919C153.404 20.2459 157.222 15.2769 165.411 15.2769C167.481 15.2769 169.092 15.5529 170.886 16.3809V20.0609C169.414 19.3719 167.85 18.9569 165.688 18.9569C159.708 18.9569 157.269 22.7289 157.269 27.1909C157.269 31.6529 159.753 35.4259 165.78 35.4259C168.127 35.4259 169.598 35.1039 171.025 34.5979V38.1399L171.024 38.1409Z"
      fill="white"
    />
    <path
      d="M175.529 38.7401V6.12207H179.486V26.5031L189.377 15.7371H194.529L183.718 27.0541L194.989 38.7401H189.607L179.486 27.9741V38.7401H175.529Z"
      fill="white"
    />
    <path
      d="M208.098 39.1999C199.495 39.1999 195.723 34.2309 195.723 27.1919C195.723 20.2459 199.587 15.2769 206.58 15.2769C213.664 15.2769 216.517 20.1999 216.517 27.1919V28.9869H199.725C200.278 32.8969 202.808 35.4269 208.237 35.4269C210.905 35.4269 213.159 34.9209 215.229 34.1849V37.8199C213.343 38.8319 210.445 39.1999 208.098 39.1999ZM199.679 25.5819H212.515C212.285 21.3039 210.353 18.8659 206.396 18.8659C202.209 18.8659 200.093 21.5799 199.679 25.5819Z"
      fill="white"
    />
    <path
      d="M230.315 35.0139C231.235 35.0139 232.109 34.8289 232.799 34.6919V38.5099C232.109 38.6949 231.326 38.8779 230.13 38.8779C225.208 38.8779 222.816 35.9799 222.816 31.7009V19.4179H219.089V15.7369H222.816V10.8599H226.68V15.7369H232.799V19.4179H226.68V31.6089C226.68 33.6329 227.876 35.0129 230.315 35.0129V35.0139Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_535"
        x1="32.494"
        y1="23.5258"
        x2="17.148"
        y2="33.9138"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.072" stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
